import { GridFilterItem } from '@mui/x-data-grid';

export const getDatagridFilterParam = (filters: GridFilterItem[]) =>
  // Stringify the filters array and then encode it for use in a URL
  `filter=${encodeURIComponent(JSON.stringify(filters))}`;
